import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ReactAudioPlayer from 'react-audio-player'
import Snowflake from "../../components/Snowflake"
import FontAwesome from 'react-fontawesome'
import { getPointData, setPointData, removeSnowflakeData, getSnowflakeViewState, setSnowflakeViewState, setAudioIsPlaying, getAudioIsPlaying} from '../../services/applicationState'
import './styles.css'

export default class HomePage extends Component {

    constructor(props) {
        super(props)
        console.log('getAudioIsPlaying', getAudioIsPlaying())
        this.headerHeight = 126 + 59
        this.footerHeight = 76
        this.mounted = false
        this.state = {
            drawWidth: window.innerWidth,
            drawHeight: window.innerHeight - (this.headerHeight + this.footerHeight),
            pointData: getPointData() || '',
            mode: getSnowflakeViewState() || 'draw',
            audioFile: 'audio/Piano-Dance.mp3',
            shouldAutoPlay: getAudioIsPlaying() == null ? true : getAudioIsPlaying() === 'true',
            audioIsPlaying:false
        }
        this.handleOnDataChange = this.handleOnDataChange.bind(this);
    }

    componentDidMount() {
        this.mounted = true
        this.updateDimensions = this.updateDimensions.bind(this);
        window.addEventListener('resize', this.updateDimensions, false)
    }

    componentWillUnmount() {
        this.mounted = false
        window.removeEventListener("resize", this.updateDimensions);
    }
    updateRef(ref) {
        if (!this.ref) {
            this.ref = ref;
            this.updateDimensions()
        }
    }
    updateDimensions() {

        //this.headerHeight = this.getPosition(this.ref).y
        //var total = this.headerHeight + this.footerHeight + 60
        //console.log('update dim')

        if (this.ref) {
            this.headerHeight = Math.max(this.getPosition(this.ref).y + 59, 126 + 59)
        }
        var total = this.headerHeight + this.footerHeight
        this.setState({
            drawWidth: window.innerWidth,
            drawHeight: window.innerHeight - total,
        });
    }

    getPosition(element) {
        var xPosition = 0;
        var yPosition = 0;

        while (element) {
            console.log(element)
            xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
            yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
            element = element.offsetParent;
        }

        return { x: xPosition, y: yPosition };
    }

    handleOnDataChange(pointData, getDataUrlFunc) {
        if(!this.mounted) return
        console.log('handleOnDataChange ' + pointData)
        this.setState({
            pointData: pointData
        })
        setPointData(pointData)
    }
    toggleMode() {
        if (!this.mounted) return
        var mode = this.getNextMode()
        this.setState({mode:mode})
        setSnowflakeViewState(mode)
    }
    getNextMode() {
        return (this.state.mode === 'draw' ? 'view' : 'draw')
    }

    clear() {
        if (getPointData()) {
            removeSnowflakeData()
            window.location.replace(process.env.PUBLIC_URL + '/create' || '/create');
        }
    }
    setAudioTag(el) {
        this.audio = el;
    }
    handleOnPlay() {
        if (!this.mounted) return
        this.audio.audioEl.volume = .25;
        this.setState({ audioIsPlaying: true})
    }
    handleOnPause() {
        if (!this.mounted) return
        this.setState({ audioIsPlaying: false })
    }

    handleTogglePlayAudio() {
        if (!this.mounted) return
        var playing = !this.state.audioIsPlaying
        this.setState({ audioIsPlaying: playing })

        if (playing) {
            this.audio.audioEl.play()
            setAudioIsPlaying(true)
        } else {
            this.audio.audioEl.pause()
            setAudioIsPlaying(false)
        }
    }

    render() {
        //var self = this;
        let mode = this.state.mode
        let snowData = this.state.pointData
        var audioButton = <button onClick={this.handleTogglePlayAudio.bind(this)} >
            {this.state.audioIsPlaying ? (
                <FontAwesome name="volume-up" />
            ) : (
                <FontAwesome name="volume-off" />
            )}
            {this.state.audioIsPlaying ? '' : ''}
        </button>

        return (
            <div ref={this.updateRef.bind(this)} className={mode === 'draw' ? 'home-page edit' : 'home-page preview'}>
                {mode === 'draw' ?
                    <div className='snow-header'>
                        {snowData &&
                            [<button onClick={this.clear.bind(this)} key='1'><FontAwesome name='undo' />Clear</button>,
                            <button onClick={this.toggleMode.bind(this)} key='2'><FontAwesome name='eye' />Preview</button>]
                        }
                         {audioButton}
                    </div>
                    :
                    <div className='snow-header'>
                        <button onClick={this.toggleMode.bind(this)}><FontAwesome name='eye-slash' />Back</button>
                        <Link to={'/message'} >
                            <FontAwesome name="arrow-right" />
                            Next
                        </Link>
                         {audioButton}
                    </div>
                }
                <Snowflake mode={this.state.mode} pointData={this.state.pointData} onDataChange={this.handleOnDataChange}
                    width={this.state.drawWidth || 1} height={this.state.drawHeight || 0}  />
                <ReactAudioPlayer
                    ref={this.setAudioTag.bind(this)}
                    src={this.state.audioFile}
                    controls={false}
                    autoPlay={this.state.shouldAutoPlay}
                    loop
                    onPlay={this.handleOnPlay.bind(this)}
                    onPause={this.handleOnPause.bind(this)}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/HomePage/index.js